module.exports = __webpack_public_path__ + "static/img/lb9.73ed0ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/lb9.png
// module id = /Bkt
// module chunks = 0